import { BulbOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import { useContext } from 'react';

import { TaskCenterContext } from 'app/context/TaskCenterContext/TaskCenterContext';
import { amplitudeTrack } from 'app/utils/track/amplitude';

export const TaskCenterButton = () => {
  const { openTaskCenter, missingTasks, doneTasks, page } =
    useContext(TaskCenterContext);

  const clickButtonTaskCenter = () => {
    openTaskCenter();
    amplitudeTrack('Open Task center', {
      from: page,
      undoneTasks: missingTasks.length,
      doneTasks: doneTasks.length,
    });
  };

  return (
    <Badge count={missingTasks.length} color="#FF2E63">
      <Button icon={<BulbOutlined />} onClick={clickButtonTaskCenter}>
        Task center
      </Button>
    </Badge>
  );
};
